import crypto from "crypto";

export const randomBytes = (length = 16) => {
    return crypto.randomBytes(length).toString('hex').toLowerCase();
}
